import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mall-inquiry-write" }
const _hoisted_2 = {
  key: 0,
  class: "mall-inquiry-write__done"
}
const _hoisted_3 = { class: "mall-inquiry-write__done-info" }
const _hoisted_4 = { class: "mall-inquiry-write__done-actions" }
const _hoisted_5 = { class: "mall-inquiry-write__body" }
const _hoisted_6 = { class: "mall-inquiry-write__field" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "mall-inquiry-write__hint"
}
const _hoisted_10 = {
  key: 1,
  class: "mall-inquiry-write__hint"
}
const _hoisted_11 = {
  key: 2,
  class: "mall-inquiry-write__hint"
}
const _hoisted_12 = {
  key: 3,
  class: "mall-inquiry-write__order"
}
const _hoisted_13 = { class: "mall-inquiry-write__order-head" }
const _hoisted_14 = { class: "mall-inquiry-write__order-status" }
const _hoisted_15 = { class: "mall-inquiry-write__order-meta" }
const _hoisted_16 = { class: "mall-inquiry-write__order-items" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "mall-inquiry-write__field" }
const _hoisted_19 = { class: "mall-inquiry-write__row" }
const _hoisted_20 = { class: "mall-inquiry-write__field" }
const _hoisted_21 = { class: "mall-inquiry-write__field" }
const _hoisted_22 = { class: "mall-inquiry-write__row" }
const _hoisted_23 = { class: "mall-inquiry-write__field" }
const _hoisted_24 = { class: "mall-inquiry-write__field" }
const _hoisted_25 = { class: "mall-inquiry-write__field" }
const _hoisted_26 = {
  key: 0,
  class: "mall-inquiry-write__error"
}
const _hoisted_27 = { class: "mall-inquiry-write__foot" }
const _hoisted_28 = ["disabled"]

import { computed, onMounted, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { createConsultPost } from '@/api/consultBoard'
import { fetchMyOrders, mallBuyerOrderStatusLabel, type MallOrder } from '@/api/mallOrder'
import { useMemberAuth } from '@/composables/useMemberAuth'
import { formatKrPhone } from '@/utils/formatPhone'
import { formatPrice } from '@/constants/mallProducts'
import { MALL_MY_CONSULTS_PATH } from '@/constants/mallMy'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallInquiryWritePage',
  setup(__props) {

const route = useRoute()
const { member } = useMemberAuth()

const form = reactive({
  orderCode: String(route.query.order || '').trim(),
  title: '',
  orgName: member.value?.orgName || '',
  orgCode: member.value?.longtermCode || '',
  contactPhone: member.value?.bossPhone || member.value?.orgPhone || '',
  email: member.value?.bossEmail || '',
  content: '',
})

const orders = ref<MallOrder[]>([])
const ordersLoading = ref(false)

/* 고른 주문이 어떤 건인지 바로 아래 카드로 보여 준다 */
const selectedOrder = computed(
  () => orders.value.find((row) => row.code === form.orderCode) || null,
)

const submitting = ref(false)
const error = ref('')
const created = ref<{ id: number; authorId: string } | null>(null)

const onContactPhoneBlur = () => {
  form.contactPhone = formatKrPhone(form.contactPhone)
}

function formatOrderOption(order: MallOrder) {
  const when = String(order.orderedAt || '').slice(0, 10)
  const summary = String(order.itemSummary || '').trim()
  return [order.code, when, summary].filter(Boolean).join(' · ')
}

function formatDateTime(value: string | null | undefined): string {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(
    date.getDate(),
  ).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

const loadOrders = async () => {
  ordersLoading.value = true
  try {
    orders.value = await fetchMyOrders()
    const fromQuery = String(route.query.order || '').trim()
    if (fromQuery && orders.value.some((row) => row.code === fromQuery)) {
      form.orderCode = fromQuery
    } else if (form.orderCode && !orders.value.some((row) => row.code === form.orderCode)) {
      form.orderCode = ''
    }
  } catch {
    orders.value = []
  } finally {
    ordersLoading.value = false
  }
}

const onSubmit = async () => {
  error.value = ''
  if (!form.orderCode) {
    error.value = '주문번호를 첨부해 주세요.'
    return
  }

  const formData = new FormData()
  formData.append('channel', 'MALL')
  formData.append('orderCode', form.orderCode)
  formData.append('title', form.title.trim())
  formData.append('orgName', form.orgName.trim())
  formData.append('orgCode', form.orgCode.trim())
  formData.append('contactPhone', formatKrPhone(form.contactPhone))
  formData.append('email', form.email.trim())
  formData.append('content', form.content.trim())

  submitting.value = true
  try {
    created.value = await createConsultPost(formData)
  } catch (e) {
    error.value = e instanceof Error ? e.message : '등록에 실패했습니다.'
  } finally {
    submitting.value = false
  }
}

onMounted(() => {
  void loadOrders()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("header", { class: "mall-inquiry-write__head" }, [
      _createElementVNode("h1", null, "문의하기"),
      _createElementVNode("p", null, "주문번호를 첨부해 문의를 작성합니다. 상품 문의와 그 밖 문의 모두 여기서 남깁니다.")
    ], -1)),
    (created.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mall-inquiry-write__done-label" }, "등록 완료", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("h2", null, "문의가 등록되었습니다", -1)),
          _createElementVNode("dl", _hoisted_3, [
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("dt", null, "글 번호", -1)),
              _createElementVNode("dd", null, _toDisplayString(created.value.id), 1)
            ])
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "mall-inquiry-write__done-note" }, " 답변이 등록되면 내가 작성한 문의에서 확인할 수 있습니다. ", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: `${_unref(MALL_MY_CONSULTS_PATH)}/${created.value.id}`,
              class: "mall-inquiry-write__btn mall-inquiry-write__btn--solid"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" 문의 내용 보기 ", -1)
              ]))]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: _unref(MALL_MY_CONSULTS_PATH),
              class: "mall-inquiry-write__btn"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("문의 내역", -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "mall-inquiry-write__panel",
          onSubmit: _withModifiers(onSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[17] || (_cache[17] = _createElementVNode("span", null, [
                _createTextVNode("주문번호 "),
                _createElementVNode("i", null, "*")
              ], -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.orderCode) = $event)),
                required: "",
                disabled: ordersLoading.value || !orders.value.length
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("option", {
                  value: "",
                  disabled: ""
                }, "주문번호를 선택해 주세요", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders.value, (order) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: order.code,
                    value: order.code
                  }, _toDisplayString(formatOrderOption(order)), 9, _hoisted_8))
                }), 128))
              ], 8, _hoisted_7), [
                [_vModelSelect, form.orderCode]
              ]),
              (ordersLoading.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, "주문 목록을 불러오는 중…"))
                : (!orders.value.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, " 주문내역이 없어 문의를 작성할 수 없습니다. "))
                  : (_openBlock(), _createElementBlock("p", _hoisted_11, " 문의에는 내 주문번호가 첨부됩니다. ")),
              (selectedOrder.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("strong", null, _toDisplayString(selectedOrder.value.code), 1),
                      _createElementVNode("em", _hoisted_14, _toDisplayString(_unref(mallBuyerOrderStatusLabel)(selectedOrder.value)), 1)
                    ]),
                    _createElementVNode("dl", _hoisted_15, [
                      _createElementVNode("div", null, [
                        _cache[14] || (_cache[14] = _createElementVNode("dt", null, "주문일시", -1)),
                        _createElementVNode("dd", null, _toDisplayString(formatDateTime(selectedOrder.value.orderedAt)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[15] || (_cache[15] = _createElementVNode("dt", null, "결제금액", -1)),
                        _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(selectedOrder.value.totalAmount)) + "원", 1)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_16, [
                      _createTextVNode(_toDisplayString(selectedOrder.value.itemSummary || '주문 상품') + " ", 1),
                      (selectedOrder.value.itemCount > 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "외 " + _toDisplayString(selectedOrder.value.itemCount - 1) + "건", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_router_link, {
                      to: `/mall/orders/${encodeURIComponent(selectedOrder.value.code)}`,
                      class: "mall-inquiry-write__order-link"
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode(" 주문 상세 보기 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("label", _hoisted_18, [
              _cache[18] || (_cache[18] = _createElementVNode("span", null, [
                _createTextVNode("제목 "),
                _createElementVNode("i", null, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.title) = $event)),
                type: "text",
                required: "",
                maxlength: "50",
                placeholder: "문의 제목"
              }, null, 512), [
                [_vModelText, form.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, [
                _cache[19] || (_cache[19] = _createElementVNode("span", null, [
                  _createTextVNode("기관명 "),
                  _createElementVNode("i", null, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.orgName) = $event)),
                  type: "text",
                  required: "",
                  maxlength: "20"
                }, null, 512), [
                  [_vModelText, form.orgName]
                ])
              ]),
              _createElementVNode("label", _hoisted_21, [
                _cache[20] || (_cache[20] = _createElementVNode("span", null, [
                  _createTextVNode("기관 기호 "),
                  _createElementVNode("i", null, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.orgCode) = $event)),
                  type: "text",
                  required: "",
                  maxlength: "11"
                }, null, 512), [
                  [_vModelText, form.orgCode]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, [
                _cache[21] || (_cache[21] = _createElementVNode("span", null, [
                  _createTextVNode("연락처 "),
                  _createElementVNode("i", null, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.contactPhone) = $event)),
                  type: "tel",
                  required: "",
                  inputmode: "numeric",
                  maxlength: "13",
                  placeholder: "01012345678",
                  autocomplete: "tel",
                  onBlur: onContactPhoneBlur
                }, null, 544), [
                  [_vModelText, form.contactPhone]
                ])
              ]),
              _createElementVNode("label", _hoisted_24, [
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "이메일 주소", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.email) = $event)),
                  type: "email",
                  maxlength: "50",
                  placeholder: "example@email.com",
                  autocomplete: "email"
                }, null, 512), [
                  [_vModelText, form.email]
                ])
              ])
            ]),
            _createElementVNode("label", _hoisted_25, [
              _cache[23] || (_cache[23] = _createElementVNode("span", null, [
                _createTextVNode("상담 내용 "),
                _createElementVNode("i", null, "*")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.content) = $event)),
                rows: "8",
                required: "",
                maxlength: "5000",
                placeholder: "문의 내용을 입력해 주세요."
              }, null, 512), [
                [_vModelText, form.content]
              ])
            ]),
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_router_link, {
              to: _unref(MALL_MY_CONSULTS_PATH),
              class: "mall-inquiry-write__btn"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("취소", -1)
              ]))]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("button", {
              type: "submit",
              class: "mall-inquiry-write__btn mall-inquiry-write__btn--solid",
              disabled: submitting.value || ordersLoading.value || !form.orderCode
            }, _toDisplayString(submitting.value ? '등록 중...' : '문의 등록'), 9, _hoisted_28)
          ])
        ], 32))
  ]))
}
}

})